<template>
    <div class="card-deal-params-block">
        <el-row v-if="canViewField('in_production_id') && isValueVisible(in_production_id, 'in_production_id')">
            <el-col :span="10">
                <span class="gray">
                    В производстве
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'in_production_id')">
                    <el-select
                        v-model="in_production_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        clearable
                        placeholder="В производстве"
                        size="mini"
                    >
                        <el-option v-for="item in factoriesList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <div class="field-error" v-if="errors.in_production_id" v-text="errors.in_production_id[0]"></div>
                </template>
                <template v-else>
                    {{ inProductionName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('production_cost') && isValueVisible(production_cost, 'production_cost')">
            <el-col :span="10">
                <span class="gray">
                    Сумма в производство
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'production_cost')">
                    <auto-numeric
                        v-model="production_cost"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.production_cost" v-text="errors.production_cost[0]"></div>
                </template>
                <template v-else>
                    {{ production_cost | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('square_m2') && isValueVisible(square_m2, 'square_m2')">
            <el-col :span="10">
                <span class="gray">
                    Квадратура, м2
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'square_m2')">
                    <el-input size="mini" autocomplete="off" type="text" v-model="square_m2" />
                    <div class="field-error" v-if="errors.square_m2" v-text="errors.square_m2[0]"></div>
                </template>
                <template v-else>
                    {{ square_m2 }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('profile_type_id') && isValueVisible(profile_type_id, 'profile_type_id')">
            <el-col :span="10">
                <span class="gray">
                    Тип профиля
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'profile_type_id')">
                    <el-select
                        v-model="profile_type_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        clearable
                        placeholder="профиль"
                        size="mini"
                    >
                        <el-option v-for="item in profileTypes" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <div class="field-error" v-if="errors.profile_type_id" v-text="errors.profile_type_id[0]"></div>
                </template>
                <template v-else>
                    {{ profileTypeName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('delivery_date') && isValueVisible(delivery_date, 'delivery_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата доставки
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'delivery_date') ">
                    <el-date-picker
                        v-model="delivery_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                    />
                    <div class="field-error" v-if="errors.delivery_date" v-text="errors.delivery_date[0]"></div>
                </template>
                <template v-else>
                    {{ delivery_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'installation_date') && isValueVisible(installation_date, 'installation_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата монтажа
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'installation_date')">
                    <el-date-picker
                        v-model="installation_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        :title="hasInstallLimitError ? installLimitErrorText : installTitle"
                        size="mini"
                        class="w100"
                        :class="hasInstallLimitError ? 'red' : ''"
                    />
                    <div class="field-error" v-if="errors.installation_date" v-text="errors.installation_date[0]"></div>
                </template>
                <template v-else>
                    {{ installation_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'finish_cost') && isValueVisible(finish_cost, 'finish_cost')">
            <el-col :span="10">
                <span class="gray">
                    Себестоимость отделки
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'finish_cost')">
                    <auto-numeric
                        v-model="finish_cost"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.finish_cost" v-text="errors.finish_cost[0]"></div>
                </template>
                <template v-else>
                    {{ finish_cost | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'jalousie_cost') && isValueVisible(jalousie_cost, 'jalousie_cost')">
            <el-col :span="10">
                <span class="gray">
                    Себестоимость жалюзи
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'jalousie_cost')">
                    <auto-numeric
                        v-model="jalousie_cost"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.jalousie_cost" v-text="errors.jalousie_cost[0]"></div>
                </template>
                <template v-else>
                    {{ jalousie_cost | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'garbage_removal_id') && isValueVisible(garbage_removal_id, 'garbage_removal_id')">
            <el-col :span="10">
                <span class="gray">
                    Вывоз мусора
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'garbage_removal_id')">
                    <el-select
                        v-model="garbage_removal_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        autocomplete
                        clearable
                        placeholder="Вывоз мусора"
                        size="mini"
                    >
                        <el-option v-for="item in garbageRemovalTypes" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <div class="field-error" v-if="errors.garbage_removal_id" v-text="errors.garbage_removal_id[0]"></div>
                </template>
                <template v-else>
                    {{ garbageRemovalName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'contractor_id') && isValueVisible(contractor_id, 'contractor_id') && [2, 3].includes(garbage_removal_id) ">
            <el-col :span="14" :offset="10">
                <template v-if="editMode && canEditField( 'contractor_id')">
                    <el-select
                        v-model="contractor_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        autocomplete
                        clearable
                        placeholder="Подрядчик"
                        size="mini"
                    >
                        <el-option v-for="item in contractorList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                    <div class="field-error" v-if="errors.contractor_id" v-text="errors.contractor_id[0]"></div>
                </template>
                <template v-else>
                    {{ contractorName }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField('is_production_paid')">
            <el-col :span="10">
                <span class="gray">
                    Производство оплачено
                </span>
            </el-col>
            <el-col :span="1">
                <font-awesome-icon icon="check-square" class="orange" v-if="is_production_paid" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { cardMixin } from '@/mixins/card';
import { pickerOptions } from '@/common/pickerOptions';

export default {
    name: 'Production',
    mixins: [
        cardMixin
    ],
    data() {
        return {
            pickerOptions,
            hasInstallLimitError: 0,
            installLimitErrorText: 'Превышен максимальный лимит монтажей за день. Проверьте настройки.',
            installTitle: ''
        };
    },
    computed: {
        inProductionName() {
            return this.$store.state.deals.current.in_production ? this.$store.state.deals.current.in_production.name : '';
        },
        factoriesList() {
            return this.$store.state.references.factories;
        },
        profileTypeName() {
            return this.$store.state.deals.current.profile_type ? this.$store.state.deals.current.profile_type.name : '';
        },
        profileTypes() {
            return this.$store.state.references.profileTypes;
        },
        garbageRemovalName() {
            return this.$store.state.deals.current.garbage_removal ? this.$store.state.deals.current.garbage_removal.name : '';
        },
        contractorName() {
            return this.$store.state.deals.current.contractor ? this.$store.state.deals.current.contractor.name : '';
        },
        garbageRemovalTypes() {
            return this.$store.state.references.garbageRemovals;
        },
        contractorList() {
            return this.$store.state.references.contractors.filter(item => item.expense_types.some(type => type.expense_type === 'Вывоз мусора'));
        },
        production_cost: {
            get() {
                return this.$store.state.deals.current.production_cost;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'production_cost', value });
            }
        },
        in_production_id: {
            get() {
                return this.$store.state.deals.current.in_production_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'in_production_id', value });
            }
        },
        jalousie_cost: {
            get() {
                return this.$store.state.deals.current.jalousie_cost;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'jalousie_cost', value });
            }
        },
        finish_cost: {
            get() {
                return this.$store.state.deals.current.finish_cost;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'finish_cost', value });
            }
        },
        delivery_date: {
            get() {
                return this.$store.state.deals.current.delivery_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'delivery_date', value });
            }
        },
        square_m2: {
            get() {
                return this.$store.state.deals.current.square_m2;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'square_m2', value });
            }
        },
        profile_type_id: {
            get() {
                return this.$store.state.deals.current.profile_type_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'profile_type_id', value });
            }
        },
        installation_date: {
            get() {
                return this.$store.state.deals.current.installation_date;
            },
            set(value) {
                this.loading = true;
                this.$store.dispatch('deals/getInstallationCountByDate', {
                    date: value
                }).then(response => {
                    const installCount = response.count + 1;
                    console.log('installCount ' + installCount);
                    console.log('settings ' + this.settings.install_limit_per_day);
                    if (this.settings && Object.prototype.hasOwnProperty.call(this.settings, 'install_limit_per_day')) {
                        if (installCount > this.settings.install_limit_per_day) {
                            this.hasInstallLimitError = 1;
                            this.$message({
                                showClose: true,
                                message: this.installLimitErrorText + ' (' + this.settings.install_limit_per_day + 'монтажей/день' + ')',
                                type: 'error',
                                duration: 5000,
                                customClass: this.alertClass()
                            });
                        } else {
                            this.hasInstallLimitError = 0;
                            this.$store.commit('deals/setCurrentField', { field: 'installation_date', value });
                        }
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        garbage_removal_id: {
            get() {
                return this.$store.state.deals.current.garbage_removal_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'garbage_removal_id', value });
            }
        },
        contractor_id: {
            get() {
                return this.$store.state.deals.current.contractor_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'contractor_id', value });
            }
        },
        is_production_paid: {
            get() {
                return this.$store.state.deals.current.is_production_paid;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'is_production_paid', value });
            }
        },
        settings() {
            return this.$store.state.auth.settings;
        }
    }
};
</script>
